import { render } from "./ProceduresDashboardPage.vue?vue&type=template&id=54e63a3d"
import script from "./ProceduresDashboardPage.vue?vue&type=script&lang=js"
export * from "./ProceduresDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__